import React, { MutableRefObject } from 'react';
import { CSSProp } from 'styled-components/macro';

interface PersonalisationOptionsListItemProps {
  onFocus: () => void;
  cssProp: CSSProp;
  children: React.ReactNode;
  listItemRef: MutableRefObject<HTMLLIElement | null> | null;
}

export const PersonalisationOptionsListItem = ({
  onFocus,
  children,
  cssProp,
  listItemRef,
}: PersonalisationOptionsListItemProps) =>
  listItemRef ? (
    <li onFocus={onFocus} ref={listItemRef} css={cssProp}>
      {children}
    </li>
  ) : (
    <li onFocus={onFocus} css={cssProp}>
      {children}
    </li>
  );
